import { Formik, Field, Form } from 'formik';
import * as React from 'react';

import { submitAnswerDelay } from '../config';
import { SurveyConfigQuestion } from '../types';

import FormikAutoSubmit from '../components/FormikAutoSubmit';
import SurveyLoadingInline from '../components/SurveyLoadingInline';
import SurveyOption from '../components/SurveyOption';
import SurveyQuestion from '../components/SurveyQuestion';

export type QuestionProps = {
  currentQuestion: SurveyConfigQuestion;
  formatHint: (isLoading: boolean, isValid: boolean) => React.ReactNode;
  onSubmit: (answerUid: string) => Promise<void>;
};

const Question = ({ currentQuestion, formatHint, onSubmit }: QuestionProps) => (
  <Formik
    initialValues={{
      answerUid: ''
    }}
    validate={(values) => {
      const errors: Partial<Record<keyof typeof values, string>> = {};

      if (values.answerUid === '') {
        errors.answerUid = 'Required';
      }

      return errors;
    }}
    validateOnMount
    onSubmit={async (values) => {
      await onSubmit(values.answerUid);
    }}
  >
    {({ isValid, isSubmitting }) => (
      <Form>
        <FormikAutoSubmit delay={submitAnswerDelay} />

        <SurveyQuestion
          subline={currentQuestion.question}
          hint={
            isSubmitting ? (
              <SurveyLoadingInline>
                {formatHint(isSubmitting, isValid)}
              </SurveyLoadingInline>
            ) : (
              formatHint(isSubmitting, isValid)
            )
          }
        >
          {currentQuestion.answerOptions.map((answer) => (
            <Field
              as={SurveyOption}
              id={answer.uid}
              key={answer.uid}
              name="answerUid"
              type="radio"
              value={answer.uid}
              required
            >
              {answer.label}
            </Field>
          ))}
        </SurveyQuestion>
      </Form>
    )}
  </Formik>
);

export default Question;
